import { Link as MortarLink } from '@policygenius/mortar';
import React, { MouseEvent } from 'react';

import { CLICKED_LINK_EVENT } from 'analytics/constants';
import { frontendAnalyticsTrack } from 'analytics/utils';

import { Props } from './types';

const Link: React.FC<Props> = ({
  analyticsProperties,
  children,
  className,
  href,
  onClick,
  size,
  target,
  variant,
  ...otherLinkProps
}) => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (
    event: MouseEvent<HTMLAnchorElement>
  ) => {
    if (analyticsProperties) {
      frontendAnalyticsTrack(CLICKED_LINK_EVENT, {
        href,
        type: variant,
        ...analyticsProperties,
      });
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <MortarLink
      variant={variant}
      className={className}
      href={href}
      onClick={handleClick}
      size={size}
      target={target}
      {...otherLinkProps}
    >
      {children}
    </MortarLink>
  );
};

export default Link;
